import { Effect, Layer, Result, Scope } from "effect";
import { tabStripFailure } from "./tab-strip-model.ts";
import { TabStripIo } from "./tab-strip-service.ts";
const metrics = (target: HTMLElement) => ({ scrollLeft: target.scrollLeft, scrollWidth: target.scrollWidth, clientWidth: target.clientWidth });
export const TabStripIoLive = Layer.succeed(TabStripIo, {
  measure: target => Effect.try({ try: () => metrics(target), catch: tabStripFailure }),
  watch: (target, notify, canRead, report) => Effect.gen(function* () {
    const owner = yield* Scope.Scope;
    const alive = () => owner.state._tag !== "Closed" && canRead();
    if (!alive() || typeof ResizeObserver === "undefined") return;
    const observer = yield* Effect.try({ try: () => new ResizeObserver(() => {
      if (!alive()) return;
      const result = Result.try(() => notify(metrics(target)));
      if (Result.isFailure(result)) report(tabStripFailure(result.failure));
    }), catch: tabStripFailure });
    yield* Effect.addFinalizer(() => Effect.try({ try: () => observer.disconnect(), catch: tabStripFailure }).pipe(Effect.orDie));
    if (alive()) yield* Effect.try({ try: () => observer.observe(target), catch: tabStripFailure });
  }),
  page: (target, direction) => Effect.try({ try: () => target.scrollBy({ left: direction * Math.max(120, target.clientWidth * 0.8), behavior: "smooth" }), catch: tabStripFailure }),
  wheel: (target, value) => Effect.try({ try: () => { if (target.scrollWidth > target.clientWidth) target.scrollLeft += value.deltaY !== 0 ? value.deltaY : value.deltaX; }, catch: tabStripFailure })
});
